import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LogEvent, SetEventProperties } from '@app/core/states/event-tracking.actions';
import { UiModule } from '@app/ui';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngxs/store';

@Component({
  selector: 'rk-settings-confirmation-modal',
  imports: [TranslatePipe, UiModule],
  templateUrl: './settings-confirmation-modal.component.html',
  styleUrl: './settings-confirmation-modal.component.scss',
})
export class SettingsConfirmationModalComponent implements OnInit {
  constructor(
    private readonly dialogRef: MatDialogRef<SettingsConfirmationModalComponent>,
    private readonly store: Store,
  ) {}

  ngOnInit(): void {
    this.store.dispatch(
      new SetEventProperties({
        name: 'ModalConfirmSettingsUpdate',
        component: 'ModalConfirmSettingsUpdate',
      }),
    );

    this.store.dispatch(new LogEvent('Modal Viewed'));
  }

  onCancel(): void {
    this.dialogRef.close({ save: false, redirect: false });

    this.store.dispatch(
      new SetEventProperties({
        name: 'ButtonCancelChanges',
        component: 'ModalConfirmSettingsUpdate',
      }),
    );

    this.store.dispatch(new LogEvent('Button Clicked'));
  }

  onSaveSettings(): void {
    this.dialogRef.close({ save: true, redirect: false });

    this.store.dispatch(
      new SetEventProperties({
        name: 'ButtonSaveChangesNoRedirect',
        component: 'ModalConfirmSettingsUpdate',
      }),
    );

    this.store.dispatch(new LogEvent('Button Clicked'));
  }

  onSaveSettingsAndRedirect(): void {
    this.dialogRef.close({ save: true, redirect: true });

    this.store.dispatch(
      new SetEventProperties({
        name: 'ButtonSaveChangesAndRedirect',
        component: 'ModalConfirmSettingsUpdate',
      }),
    );

    this.store.dispatch(new LogEvent('Button Clicked'));
  }
}
